package com.essntl.features.address.domain.model

data class GooglePlaceModel(
    val placeId: String,
    val description: String,
    val mainText: String,
    val secondaryText: String,
)
